<template>
  <div>
    <div v-if="isMobile">
      <v-expansion-panels dark>
        <v-expansion-panel>
          <v-expansion-panel-header :color="getThemeColor"
            >Click To Hide Or Show Some Columns</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-row>
              <v-col v-for="(column, i) in allColumns" :key="i">
                <v-checkbox
                  v-model="selectedColumns"
                  :label="column.text"
                  :value="column"
                  color="blue"
                  @click="hideOrShowSelectedColumns()"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else>
      <v-row>
        <v-col v-for="(column, i) in allColumns" :key="i">
          <v-checkbox
            v-model="selectedColumns"
            :label="column.text"
            :value="column"
            color="blue"
            @click="hideOrShowSelectedColumns()"
          ></v-checkbox>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      default: () => [],
    },
  },
  watch: {
    headers(newVal) {
      this.allColumns = newVal;
      this.selectedColumns = newVal;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  mounted() {
    this.allColumns = this.headers;
    this.selectedColumns = this.headers;
  },
  data: () => ({
    allColumns: [],
    selectedColumns: [],
  }),
  methods: {
    hideOrShowSelectedColumns() {
      this.$emit("column-clicked", this.selectedColumns);
    },
  },
};
</script>
